module.exports = __webpack_public_path__ + "img/construction-regular.fd4cd23e.png";